/**
 * Модель записи в store 'tables' до миграции.
 * Содержит список полей с метаданными и статусом отображения.
 */
export interface tablesStoreInterface {
  id: number;
  name: string;
  fields: { displayedName: string; name: string; sort: number; status: boolean }[]
}

/**
 * Фабрика функций миграций IndexedDB по версиям.
 *
 * Возвращает словарь, где ключ — номер версии, а значение — функция миграции,
 * выполняемая в рамках апгрейда базы: изменение структуры хранилищ, преобразование данных и т.д.
 */
export function migrationFactory(): { [key: number]: (db: IDBDatabase, transaction: IDBTransaction) => void } {
  return {
    2: (_db, transaction) => {
      let store: IDBObjectStore = transaction.objectStore('tables');

      let all = store.getAll();
      all.onsuccess = () => {
        let result: tablesStoreInterface[] = all.result;
        result.forEach((entry: tablesStoreInterface) => {
          let enabledFields: string[] = entry.fields
            .filter(value => value.status)
            .map(value => value.name);
          store.put({id: entry.id, name: entry.name, fields: enabledFields})
        })
      }

      if (!store.indexNames.contains('fields')) return;

      store.deleteIndex('fields');
    },
    3: (_db, transaction) => {}
  }
}
